import classnames from 'classnames';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  ({ spacing, breakpoints }) => ({
    root: {
      padding: spacing(2, 2),
      display: 'block',
      fontSize: '100%',
      border: 0,
      textDecoration: 'none',
      background: 'none',
      fontFamily: 'inherit',
      textAlign: 'left',
      outlineWidth: 1,
      '&:active, &:visited': {
        color: 'inherit',
      },
    },

    [breakpoints.up('md')]: {
      root: {
        padding: spacing(2, 3),
      },
    },
  }),
  { classNamePrefix: 'StackableCardItem' }
);

export default function StackableCardItem({
  className = null,
  children,
  component: Component = 'section',
  ...otherProps
}) {
  const classes = useStyles();
  return (
    <Component {...otherProps} className={classnames(classes.root, className)}>
      {children}
    </Component>
  );
}
